import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { setAlert } from '../../../actions/alert';
import { crearCategoriaEmpresaConfiguracion } from '../../../actions/configuracion';

const NuevaCategoria = ({ categoria, reestablecerCategoria }) => {

    const dispatch =  useDispatch();

    const [nuevoModal, setNuevoModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [categoriaData, setCategoriaData] = useState({
        nombre: null
    });

    /* Crear categoria */
    const handleInputChange = ({ target }) => {
        setCategoriaData({
            ...categoriaData,
            [target.name]: target.value
        });
    }
    
    const handleProcesar = async () => {
        if(categoriaData.nombre){
            await setStatusProcesar(true);
            await dispatch(crearCategoriaEmpresaConfiguracion(categoriaData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Completa todos los campos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setCategoriaData({
                nombre: null
            });
            setNuevoModal(false);
            reestablecerCategoria(null);
        }
    }

    useEffect(() => {
        if(categoria){
            setNuevoModal(true);

            setCategoriaData({
                ...categoriaData
            });
        }        
    }, [categoria]);

    return (
        <Modal show={nuevoModal} size="md" backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Agregar categoria</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-2">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={categoriaData.nombre} onChange={e => handleInputChange(e)}/>
                                <label htmlFor="nombre">Nombre</label>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Agregar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Agregar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default NuevaCategoria;